import React from 'react';
import {
  DragDropContext as RBDragDropContext,
  DropResult,
} from '@hello-pangea/dnd';

interface Props {
  /**
   * A handler that is triggered when a downstream <Draggable />
   * has been dragged and dropped within a <Droppable />
   */
  onDragEnd: (result: DropResult) => void;
  children: React.ReactNode;
}

// A <DragDropContext /> contains <Droppable /> and <Draggable />

export const DragDropContext = ({ onDragEnd, children }: Props) => {
  return (
    <RBDragDropContext onDragEnd={onDragEnd}>{children}</RBDragDropContext>
  );
};
